module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Best/Worst","top_fail":"Organizations with the most issues","top_win":"Organizations with very few to zero issues"},"nl":{"title":"Beste/Slechtste","top_fail":"Organisaties met de meeste risico\u0027s","top_win":"Organisaties met de minste tot geen risico"}}')
  delete Component.options._Ctor
}
